import React from "react";
import LibraryPdfItem from "@/react-components/LibraryPdfItem";
import i18n from "i18next";
import { api } from "@/utils/api";

class TrendCommentary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfInfos: undefined,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.library
      .getTrendList()
      .then((res) => {
        this.setState({
          pdfInfos: res,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  render() {
    const { pdfInfos } = this.state;
    return (
      <div className="library-container">
        <div className="summary-container">{i18n.t("TCLs0007_sumarry")}</div>
        <div className="line"></div>
        <div className="library-container-area">
          {pdfInfos && pdfInfos.length > 0
            ? pdfInfos.map((item, index) => (
                <LibraryPdfItem key={index} item={item} />
              ))
            : ""}
        </div>
      </div>
    );
  }
}

export default TrendCommentary;
